import React, { memo } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ChatMessage.module.css";

interface MessageSectionProps {
  content: string;
  index: number;
  messageId: string;
  role: "user" | "assistant" | "system";
}

const MessageSection: React.FC<MessageSectionProps> = ({ content, role }) => {
  return (
    <Text
      className={toClassName(styles.messageSection, {
        [styles.messageUser]: role === "user",
        [styles.messageAssistant]: role === "assistant",
      })}
    >
      {content}
    </Text>
  );
};

export default memo(MessageSection);
